<template>
  <v-container id="payemtlogs" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="light-blue"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn color="black" class="mr-0" fab small text @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="3" lg="3">
              <v-text-field v-model="filters.name" :label="$i18n.t('Name')" />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right:10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width:100%"
      :loading="loading"
    >{{ $i18n.t("No records available") }}</v-btn>

    <base-material-card
      icon="mdi-card-text-outline"
      :title="$i18n.t('Truck Types')"
      class="px-5 py-3 small-icon"
      v-if="grid.records"
    >
      <z-grid-record :grid="grid" />

      <v-card class="py-0 my-2" elevation="1" color="blue lighten-5 d-none d-md-flex">
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-row>
                <v-col cols="12" md="3" lg="3">{{ $i18n.t("Name")}}</v-col>
                <v-col
                  cols="12"
                  md="3"
                  lg="3"
                >{{ $i18n.t("Min / Max Weight") + " ("+$i18n.t("KGs")+")"}}</v-col>
                <v-col
                  cols="12"
                  md="3"
                  lg="3"
                >{{ $i18n.t("Dimension") + $i18n.t("(L x W x H)" + " ("+$i18n.t("CMs")+")")}}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-virtual-scroll
        :bench="5"
        :items="grid.rows"
        :height="gridHeight"
        :item-height="itemHeight"
      >
        <template v-slot="{item}">
          <v-row>
            <v-col cols="12" xs="11" sm="12" md="12" lg="12">
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3">{{item.name}}</v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3">{{item.minWt}} / {{item.maxWt}}</v-col>
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="3"
                  lg="3"
                >{{item.dalaLength}} x {{item.dalaWidth}} x {{item.dalaHeight}}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-virtual-scroll>

      <v-container>
        <v-pagination
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "PaymentLogs",
})
export default class Bills extends Vue {
  grid = { page: 0, rows: [] };
  url = "/api/vtgroup/data/grid?";
  showFilter = false;
  filterUrl = "";
  on = null;
  page = 1;
  rows = 50;

  filters = {
    name: null,
  };

  get loading() {
    return common.loading;
  }

  get gridHeight() {
    return this.windowHeight > 500 ? this.windowHeight - 150 : 300;
  }

  get itemHeight() {
    return this.windowWidth > 960 ? 75 : 240;
  }

  async mounted() {
    this.showPage(1);
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    try {
      const grid = await doGet(
        this.url + "rows=" + this.rows + "&page=" + page + this.filterUrl
      );
      this.grid = grid;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  async refresh(__i) {
    if (__i == 1) {
      this.search();
    }
  }

  async search(download) {
    this.filterUrl = "";
    let url = "";
    if (this.filters.name) url += "&name=" + this.filters.name;
    this.filterUrl = url;
    await this.showPage(1);
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  async reload() {
    this.showPage(this.page);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
